"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.image.alt': 'AI Assistant Avatar',
};
